export const timeArr = [
  {
    label: '00:00',
    value: '12:00 AM',
  },
  {
    label: '00:30',
    value: '12:30 AM',
  },
  {
    label: '1:00',
    value: '1:00 AM',
  },
  {
    label: '1:30',
    value: '1:30 AM',
  },
  {
    label: '2:00',
    value: '2:00 AM',
  },
  {
    label: '2:30',
    value: '2:30 AM',
  },
  {
    label: '3:00',
    value: '3:00 AM',
  },
  {
    label: '3:30',
    value: '3:30 AM',
  },
  {
    label: '4:00',
    value: '4:00 AM',
  },
  {
    label: '4:30',
    value: '4:30 AM',
  },
  {
    label: '5:00',
    value: '5:00 AM',
  },
  {
    label: '5:30',
    value: '5:30 AM',
  },
  {
    label: '6:00',
    value: '6:00 AM',
  },
  {
    label: '6:30',
    value: '6:30 AM',
  },
  {
    label: '7:00',
    value: '7:00 AM',
  },
  {
    label: '7:30',
    value: '7:30 AM',
  },
  {
    label: '8:00',
    value: '8:00 AM',
  },
  {
    label: '8:30',
    value: '8:30 AM',
  },
  {
    label: '9:00',
    value: '9:00 AM',
  },
  {
    label: '9:30',
    value: '9:30 AM',
  },
  {
    label: '10:00',
    value: '10:00 AM',
  },
  {
    label: '10:30',
    value: '10:30 AM',
  },
  {
    label: '11:00 ',
    value: '11:00 AM',
  },
  {
    label: '11:30',
    value: '11:30 AM',
  },
  {
    label: '12:00',
    value: '12:00 PM',
  },
  {
    label: '12:30',
    value: '12:30 PM',
  },
  {
    label: '13:00',
    value: '1:00 PM',
  },
  {
    label: '13:30',
    value: '1:30 PM',
  },
  {
    label: '14:00',
    value: '2:00 PM',
  },
  {
    label: '14:30',
    value: '2:30 PM',
  },
  {
    label: '15:00',
    value: '3:00 PM',
  },
  {
    label: '15:30',
    value: '3:30 PM',
  },
  {
    label: '16:00',
    value: '4:00 PM',
  },
  {
    label: '16:30',
    value: '4:30 PM',
  },
  {
    label: '17:00',
    value: '5:00 PM',
  },
  {
    label: '17:30',
    value: '5:30 PM',
  },
  {
    label: '18:00',
    value: '6:00 PM',
  },
  {
    label: '18:30',
    value: '6:30 PM',
  },
  {
    label: '19:00',
    value: '7:00 PM',
  },
  {
    label: '19:30',
    value: '7:30 PM',
  },
  {
    label: '20:00',
    value: '8:00 PM',
  },
  {
    label: '20:30',
    value: '8:30 PM',
  },
  {
    label: '21:00',
    value: '9:00 PM',
  },
  {
    label: '21:30',
    value: '9:30 PM',
  },
  {
    label: '22:00',
    value: '10:00 PM',
  },
  {
    label: '22:30',
    value: '10:30 PM',
  },
  {
    label: '23:00',
    value: '11:00 PM',
  },
  {
    label: '23:30',
    value: '11:30 PM',
  },
];
